import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { ReactComponent as BackSVG } from "go-core/images/svg/back.svg";
import { OrderContext } from "../contexts/OrderContext";
import { getOrderBackRedirect } from "../utils";

const HeaderBack = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const location = useLocation();
	const { matchUrl, order } = useContext(OrderContext);

	if (window.self !== window.top) return <></>;

	return (
		<div className="header-back" data-testid="e-order-header-back">
			<div
				className="d-flex align-items-center gap-3"
				onClick={() => history.replace(getOrderBackRedirect(matchUrl, order, location))}
			>
				<BackSVG />
				<h1>{t("modules.e_order.action.go_back.title")}</h1>
			</div>
		</div>
	);
};

export default HeaderBack;
